import { t } from '@lingui/core/macro';
import moment from 'moment';

export const formatElapsedTime = (seconds: number | null): string => {
  if (!seconds) return '-';
  if (seconds < 300) return `< 5 ${t`min`}`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)} ${t`min`}`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)} ${t`h`}`;
  if (seconds < 2592000) return `${Math.floor(seconds / 86400)} ${t`jour(s)`}`;
  if (seconds < 31536000) return `${Math.floor(seconds / 2419200)} ${t`mois`}`;

  return `${Math.floor(seconds / 29030400)} ${t`an(s)`}`;
};

export const getLastDayOfMonth = (date: Date): Date =>
  new Date(date.getFullYear(), date.getMonth() + 1, 0);

export const checkIfDatesAreEqual = (dateA: Date, dateB: Date) =>
  dateA.getFullYear() === dateB.getFullYear() &&
  dateA.getMonth() === dateB.getMonth() &&
  dateA.getDate() === dateB.getDate();

export const definedAndBeforeToday = (date: Date | string | null): boolean => {
  const now = moment();
  return !!date && moment(date).isBefore(now, 'day');
};

export const undefinedOrBeforeNow = (date: string | null): boolean => {
  const now = moment();
  return !date || moment(date).isBefore(now);
};

export const definedAndAfterNow = (date: string | null): boolean => {
  const now = moment();
  return !!date && moment(date).isAfter(now);
};

export const definedAndTodayOrAfter = (date: Date | string | null): boolean =>
  !!date && moment(date).isSameOrAfter(moment(), 'day');

export const oneDayFromNow = () => {
  const now = new Date();
  now.setHours(now.getHours() + 24);
  return now;
};
